export var TitleDataHooks;
(function (TitleDataHooks) {
    TitleDataHooks["Title"] = "title-title";
    TitleDataHooks["SubTitle"] = "title-subtitle";
    TitleDataHooks["Content"] = "title-children-container";
})(TitleDataHooks || (TitleDataHooks = {}));
//# sourceMappingURL=constants.js.map